import { render } from "./Capital.vue?vue&type=template&id=cb559e6e&scoped=true"
import script from "./Capital.vue?vue&type=script&lang=ts"
export * from "./Capital.vue?vue&type=script&lang=ts"

import "./Capital.vue?vue&type=style&index=0&id=cb559e6e&scoped=true&lang=scss"
import "./Capital.vue?vue&type=style&index=1&id=cb559e6e&lang=css"
script.render = render
script.__scopeId = "data-v-cb559e6e"

export default script